import { CheckCircle2, ShieldCheck, Globe, HeartHandshake, Mail, CalendarClock } from "lucide-react";

function StatusRow({ icon: Icon, label, meta }) {
  return (
    <div className="flex items-center justify-between py-2.5 px-3 rounded-lg hover:bg-charcoal-50 transition-colors duration-200">
      <div className="flex items-center gap-2.5">
        <Icon className="w-4 h-4 text-charcoal-400" strokeWidth={1.75} />
        <span className="text-sm text-charcoal-800">{label}</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="hidden sm:inline text-[11px] font-mono text-charcoal-400">{meta}</span>
        <CheckCircle2 className="w-4 h-4 text-emerald-500" strokeWidth={2} />
      </div>
    </div>
  );
}

export default function DashboardMockup() {
  return (
    <div className="relative w-full max-w-md mx-auto" data-testid="hero-dashboard-mockup">
      <div className="rounded-2xl bg-white border border-black/5 shadow-premium overflow-hidden">
        {/* window chrome */}
        <div className="flex items-center gap-1.5 px-4 py-3 border-b border-black/5 bg-charcoal-50/60">
          <span className="w-2.5 h-2.5 rounded-full bg-charcoal-100" />
          <span className="w-2.5 h-2.5 rounded-full bg-charcoal-100" />
          <span className="w-2.5 h-2.5 rounded-full bg-charcoal-100" />
          <span className="ml-3 text-[11px] font-mono text-charcoal-400">missionwatch.app/report</span>
        </div>

        <div className="p-5">
          {/* score */}
          <div className="flex items-center justify-between mb-5">
            <div>
              <p className="text-[11px] font-mono uppercase tracking-[0.15em] text-charcoal-400">Overall Health</p>
              <div className="flex items-end gap-2 mt-1">
                <span className="text-4xl font-semibold tracking-tighter text-charcoal-900">98</span>
                <span className="text-charcoal-400 mb-1 text-sm">/ 100</span>
              </div>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-100">
              <span className="w-2 h-2 rounded-full bg-emerald-500 dot-pulse" />
              <span className="text-xs font-medium text-emerald-700 font-mono">All Healthy</span>
            </div>
          </div>

          {/* checks */}
          <div className="space-y-0.5 border-t border-black/5 pt-2">
            <StatusRow icon={Globe} label="Website" meta="240ms" />
            <StatusRow icon={HeartHandshake} label="Donation Page" meta="tested 2h ago" />
            <StatusRow icon={Mail} label="Contact Form" meta="delivered" />
            <StatusRow icon={ShieldCheck} label="SSL Certificate" meta="214 days" />
            <StatusRow icon={Globe} label="Domain Status" meta="active" />
          </div>

          {/* reminders */}
          <div className="mt-4 rounded-xl bg-charcoal-50 border border-black/5 p-3.5">
            <div className="flex items-center gap-2 mb-2">
              <CalendarClock className="w-3.5 h-3.5 text-brand" strokeWidth={2} />
              <span className="text-[11px] font-mono uppercase tracking-[0.12em] text-charcoal-500">Upcoming Reminders</span>
            </div>
            <div className="flex items-center justify-between text-sm py-1">
              <span className="text-charcoal-800">Insurance Renewal</span>
              <span className="font-mono text-xs text-charcoal-400">Feb 14</span>
            </div>
            <div className="flex items-center justify-between text-sm py-1">
              <span className="text-charcoal-800">Annual Registration</span>
              <span className="font-mono text-xs text-charcoal-400">Mar 01</span>
            </div>
          </div>
        </div>
      </div>

      {/* floating badge */}
      <div className="absolute -bottom-4 -right-3 sm:-right-6 rounded-xl bg-charcoal-900 text-white shadow-premium px-4 py-3 flex items-center gap-2.5">
        <CheckCircle2 className="w-4 h-4 text-emerald-400" strokeWidth={2} />
        <span className="text-xs font-medium">Checked this month</span>
      </div>
    </div>
  );
}
